const themeContract = {
  tu: {
    heading: {
      display: 'display-3',
      color: 'brand-1'
    },
    hover: {
      color: 'grey-80'
    },
    border: {
      color: 'black'
    },
    pills: {
      overrideBackground: true,
      backgroundColor: 'lighter',
      textColor: 'black',
      hover: {
        backgroundColor: 'light'
      }
    }
  },
  argos: {
    heading: {
      display: 'display-1',
      color: 'grey-80'
    },
    hover: {
      color: 'grey-80'
    },
    border: {
      color: 'black'
    },
    pills: {
      overrideBackground: true,
      backgroundColor: 'lighter',
      textColor: 'black',
      hover: {
        backgroundColor: 'lighter'
      }
    }
  },
  habitat: {
    heading: {
      display: 'display-1',
      color: 'brand-1'
    },
    hover: {
      color: 'grey-80'
    },
    border: {
      color: 'black'
    },
    pills: {
      overrideBackground: true,
      backgroundColor: 'lighter',
      textColor: 'black',
      hover: {
        backgroundColor: 'light'
      }
    }
  },
  nectar: {
    heading: {
      display: 'display-3',
      color: 'purple-90'
    },
    hover: {
      color: 'grey-80'
    },
    border: {
      color: 'black'
    },
    pills: {
      overrideBackground: true,
      backgroundColor: 'lighter',
      textColor: 'black',
      hover: {
        backgroundColor: 'light'
      }
    }
  },
  sainsburys: {
    heading: {
      display: 'display-2',
      color: 'grey-80'
    },
    hover: {
      color: 'grey-80'
    },
    border: {
      color: 'black'
    },
    pills: {
      overrideBackground: true,
      backgroundColor: 'lighter',
      textColor: 'black',
      hover: {
        backgroundColor: 'light'
      }
    }
  }
}

export { themeContract }
